import { render, staticRenderFns } from "./payment2.vue?vue&type=template&id=4b5c208e&scoped=true&"
import script from "./payment2.vue?vue&type=script&lang=js&"
export * from "./payment2.vue?vue&type=script&lang=js&"
import style0 from "./payment2.vue?vue&type=style&index=0&id=4b5c208e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c208e",
  null
  
)

export default component.exports